@if (isAddAreaVisible()) {
  <yo-fermeture-add-area
    [activeTab]="activeTab()"
    (jourLinesReady)="onJourLinesReady($event)"
    (periodeLinesReady)="onPeriodeLinesReady($event)"
    (closeRequested)="closeAddArea()">
  </yo-fermeture-add-area>
}

<dx-tab-panel
  class="fermeture-tab-panel"
  [selectedIndex]="activeTabIndex()"
  [deferRendering]="false"
  (onTitleClick)="onTabChange($event)">

  <dxi-item title="Fermeture récurrente">
    <dx-data-grid
      #gridJour
      [dataSource]="fermetureClientSvc.fermeturesJourResource.value() ?? []"
      keyExpr="cmcPlcId"
      [hoverStateEnabled]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [allowColumnReordering]="true"
      [showRowLines]="true"
      [showBorders]="true"
      columnResizingMode="widget">

      <dxo-toolbar>
        <dxi-item location="before" template="btnCreerJourTemplate"></dxi-item>
        <dxi-item location="before" template="btnSupprimerJourTemplate"></dxi-item>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
      </dxo-toolbar>

      <div *dxTemplate="let _ of 'btnCreerJourTemplate'">
        <yo-button
          iconClass="fa fa-plus"
          [theme]="ButtonThemeEnum.ADD"
          label="CRÉER"
          tooltip="Ouvrir la zone de création"
          (onClick)="openAddArea()">
        </yo-button>
      </div>
      <div *dxTemplate="let _ of 'btnSupprimerJourTemplate'">
        <yo-button
          iconClass="fa fa-trash"
          [theme]="ButtonThemeEnum.DELETE_INNER"
          tooltip="Supprimer les fermetures sélectionnées"
          [disabled]="!hasSelection()"
          (onClick)="deleteSelected()">
        </yo-button>
      </div>

      <dxo-selection
        selectAllMode="allPages"
        showCheckBoxesMode="always"
        mode="multiple">
      </dxo-selection>

      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxi-column dataField="clientLibelle" caption="Client" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="pointLivraisonLibelle" caption="Point de livraison" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="prestationLibelle" caption="Prestation" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="jours" caption="Jours" [allowFiltering]="false"
        cellTemplate="joursCellTemplate">
      </dxi-column>

      <div *dxTemplate="let cell of 'joursCellTemplate'">
        {{cell.row.data.jours | jourSemaineList}}
      </div>

      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20,50,100]"
        [visible]="true" [showInfo]="true" infoText="{2} fermeture(s)">
      </dxo-pager>
    </dx-data-grid>

    <yo-fermeture-preview-jour
      [(visible)]="isPreviewJourVisible"
      [(pendingLines)]="pendingJourLines"
      (save)="savePreviewJour()">
    </yo-fermeture-preview-jour>
  </dxi-item>

  <dxi-item title="Fermeture ponctuelle">
    <dx-data-grid
      #gridPeriode
      [dataSource]="fermetureClientSvc.fermeturesPeriodeResource.value() ?? []"
      keyExpr="id"
      [hoverStateEnabled]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [allowColumnReordering]="true"
      [showRowLines]="true"
      [showBorders]="true"
      columnResizingMode="widget">

      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-toolbar>
        <dxi-item location="before" template="btnCreerPeriodeTemplate"></dxi-item>
        <dxi-item location="before" template="btnSupprimerPeriodeTemplate"></dxi-item>
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
      </dxo-toolbar>

      <div *dxTemplate="let _ of 'btnCreerPeriodeTemplate'">
        <yo-button
          iconClass="fa fa-plus"
          [theme]="ButtonThemeEnum.ADD"
          label="CRÉER"
          tooltip="Ouvrir la zone de création"
          (onClick)="openAddArea()">
        </yo-button>
      </div>
      <div *dxTemplate="let _ of 'btnSupprimerPeriodeTemplate'">
        <yo-button
          iconClass="fa fa-trash"
          [theme]="ButtonThemeEnum.DELETE_INNER"
          tooltip="Supprimer les fermetures sélectionnées"
          [disabled]="!hasSelection()"
          (onClick)="deleteSelected()">
        </yo-button>
      </div>

      <dxo-selection
        selectAllMode="allPages"
        showCheckBoxesMode="always"
        mode="multiple">
      </dxo-selection>

      <dxi-column dataField="clientLibelle" caption="Client" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="pointLivraisonLibelle" caption="Point de livraison" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="prestationLibelle" caption="Prestation" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="dateDebut" caption="Date début" dataType="date" format="dd/MM/yyyy" [width]="130"></dxi-column>
      <dxi-column dataField="dateFin" caption="Date fin" dataType="date" format="dd/MM/yyyy" [width]="130"></dxi-column>
      <dxi-column dataField="motifLibelle" caption="Motif" [allowFiltering]="true"></dxi-column>

      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20,50,100]"
        [visible]="true" [showInfo]="true" infoText="{2} fermeture(s)">
      </dxo-pager>
    </dx-data-grid>

    <yo-fermeture-preview-periode
      [(visible)]="isPreviewPeriodeVisible"
      [(pendingLines)]="pendingPeriodeLines"
      (save)="savePreviewPeriode()">
    </yo-fermeture-preview-periode>
  </dxi-item>

</dx-tab-panel>

<dx-load-panel
  [visible]="isSaving()"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0,0,0,0.2)">
</dx-load-panel>

<yo-fermeture-erreur-jour
  [(visible)]="isPlanProdErrorJourPopupVisible"
  [erreurs]="planProdErreursJour()">
</yo-fermeture-erreur-jour>

<yo-fermeture-erreur-periode
  [(visible)]="isPlanProdErrorPopupVisible"
  [erreurs]="planProdErreurs()">
</yo-fermeture-erreur-periode>
